//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

const getUia = (state: ICuralateStore) => state.uiaModal;

export const getLaunchOptions = createSelector(getUia, (uiaModal) => {
  return uiaModal.modalState.launchOptions;
});
